import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import { CircleIcon } from 'lucide-react'
import PropTypes from 'prop-types'

// Utils
import { cn } from '@/utils/helpers'

function RadioGroup({ className, ...props }) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn('grid gap-3', className)}
      {...props}
    />
  )
}

RadioGroup.propTypes = {
  className: PropTypes.string,
}

function RadioGroupItem({ className, large = false, ...props }) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        large ? 'size-12' : 'size-4',
        'border-input text-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 aspect-square shrink-0 rounded-full border-[1.5px] shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="relative flex items-center justify-center"
      >
        <CircleIcon
          className={cn(
            large ? 'size-8' : 'size-2',
            'fill-primary absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
          )}
        />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
}

RadioGroupItem.propTypes = {
  className: PropTypes.string,
  large: PropTypes.bool,
}

export { RadioGroup, RadioGroupItem }
